module.exports = __webpack_public_path__ + "img/IMG-20200911-WA0004.7d2aae2b.jpg";